import React from "react";
import { Spinner } from "reactstrap";

/** `light` opts out of the app's dark surface for the Content module. */
const Loader: React.FC<{ light?: boolean }> = ({ light }) => {
  return (
    <div
      className={`d-flex justify-content-center align-items-center${
        light ? "" : " bg-dark"
      }`}
      style={light ? undefined : { color: "white" }}
    >
      <Spinner style={{ width: "2rem", height: "2rem" }} />
      <h5 className="pl-2 mb-0" style={{ padding: "1.3rem 0" }}>
        Loading....
      </h5>
    </div>
  );
};

export default Loader;
